import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import Header from './components/Header';
import withAuth from '../hocs/withAuth';
import { drawerWidth } from '../components/drawer/BaseDrawerDesktop.styled';
import { BaseDrawerDesktop, BaseDrawerMobile } from '@libs/@core/components/drawer';
import useGetProfileData from '@libs/hooks/useGetProfileData';
import { AbilityContext } from '@libs/@core/contexts/caslContext';
import { defineAbilitiesFor } from '@libs/@core/security/ability';
import useGetMenuList from '@libs/hooks/useGetMenuList';
var HomeLayout = function () {
    var data = useGetProfileData().data;
    var theme = useTheme();
    var matches = useMediaQuery(theme.breakpoints.up('lg'));
    var ability = defineAbilitiesFor(data === null || data === void 0 ? void 0 : data.role);
    var menuList = useGetMenuList();
    return (_jsx(AbilityContext.Provider, { value: ability, children: _jsxs("div", { className: 'w-screen min-h-screen flex', children: [matches ? _jsx(BaseDrawerDesktop, { listItems: menuList }) : _jsx(BaseDrawerMobile, { listItems: menuList }), _jsxs("div", { className: 'flex flex-1 h-screen flex-col bg-secondary-mainOpacity', style: {
                        minWidth: "calc(100vw - ".concat(drawerWidth, "px)")
                    }, children: [_jsx(Header, {}), _jsx("div", { className: 'flex-1 overflow-auto', children: _jsx(Outlet, {}) })] })] }) }));
};
export default withAuth(HomeLayout);
